/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_Programs_LeadInputs */

const en_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A program`)
};

const es_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un programa`)
};

const de_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Programm`)
};

const zh_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为每位球员`)
};

const ar_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برنامج`)
};

const fr_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un programme`)
};

const vi_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chương trình`)
};

const sw_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programu`)
};

const th_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรแกรม`)
};

const bs_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program`)
};

const ja_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのプレーヤーのための`)
};

const ko_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 플레이어를 위한`)
};

const pt_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um programa`)
};

const it_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un programma`)
};

const sv_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett program`)
};

const nl_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een programma`)
};

const da_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et program`)
};

const nb_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et program`)
};

const fi_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohjelma`)
};

const pl_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program`)
};

const ru_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа`)
};

const tr_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her oyuncuya`)
};

const hi_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम`)
};

const id_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah program`)
};

const ms_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program`)
};

const cs_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program`)
};

const el_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα πρόγραμμα`)
};

const he_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוכנית`)
};

const af_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Program`)
};

const hu_home_section_programs_lead = /** @type {(inputs: Home_Section_Programs_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy program`)
};

/**
* | output |
* | --- |
* | "A program" |
*
* @param {Home_Section_Programs_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_programs_lead = /** @type {((inputs?: Home_Section_Programs_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_Programs_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_programs_lead(inputs)
	if (locale === "de") return de_home_section_programs_lead(inputs)
	if (locale === "zh") return zh_home_section_programs_lead(inputs)
	if (locale === "ar") return ar_home_section_programs_lead(inputs)
	if (locale === "fr") return fr_home_section_programs_lead(inputs)
	if (locale === "vi") return vi_home_section_programs_lead(inputs)
	if (locale === "sw") return sw_home_section_programs_lead(inputs)
	if (locale === "th") return th_home_section_programs_lead(inputs)
	if (locale === "bs") return bs_home_section_programs_lead(inputs)
	if (locale === "ja") return ja_home_section_programs_lead(inputs)
	if (locale === "ko") return ko_home_section_programs_lead(inputs)
	if (locale === "pt") return pt_home_section_programs_lead(inputs)
	if (locale === "it") return it_home_section_programs_lead(inputs)
	if (locale === "sv") return sv_home_section_programs_lead(inputs)
	if (locale === "nl") return nl_home_section_programs_lead(inputs)
	if (locale === "da") return da_home_section_programs_lead(inputs)
	if (locale === "nb") return nb_home_section_programs_lead(inputs)
	if (locale === "fi") return fi_home_section_programs_lead(inputs)
	if (locale === "pl") return pl_home_section_programs_lead(inputs)
	if (locale === "ru") return ru_home_section_programs_lead(inputs)
	if (locale === "tr") return tr_home_section_programs_lead(inputs)
	if (locale === "hi") return hi_home_section_programs_lead(inputs)
	if (locale === "id") return id_home_section_programs_lead(inputs)
	if (locale === "ms") return ms_home_section_programs_lead(inputs)
	if (locale === "cs") return cs_home_section_programs_lead(inputs)
	if (locale === "el") return el_home_section_programs_lead(inputs)
	if (locale === "he") return he_home_section_programs_lead(inputs)
	if (locale === "af") return af_home_section_programs_lead(inputs)
	if (locale === "hu") return hu_home_section_programs_lead(inputs)
	return en_home_section_programs_lead(inputs)
});